// extracted by mini-css-extract-plugin
export default {"flex":"styles_flex__0+Z+D","dash":"styles_dash__seMBY","dashComp":"styles_dashComp__lFiM8"};